export function reviewsSliderHandler() {
  // Initialize thumbs swiper first
  const photosSwiper = new Swiper('.photos-swiper', {
    slidesPerView: 4,      
    spaceBetween: 0,
    watchSlidesProgress: true, // required for thumbs
    slideToClickedSlide: true, // click photo = go to that slide
    //slidesOffsetBefore: 12,
    slidesOffsetAfter: 0,
    direction: 'vertical',

    breakpoints: {
      1025: {
        direction: 'horizontal',
        slidesPerView: 'auto'
      }
    },

    // Smooth scroll to slides
    speed: 300,
    
    // Prevent snapping issues
    resistanceRatio: 0,

  });


  const reviewsSwiper = new Swiper('.reviews-swiper', {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true 
    },
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.reviews-nav__next',
      prevEl: '.reviews-nav__prev',
    },
    thumbs: {
      swiper: photosSwiper, // link to photos swiper
    },

    breakpoints: {
      1025: {
        autoHeight: false,
      }
    },
  });
}

